<template>
  <div class="view-wrap">
    <div class="view-content">
      <section>
        <div class="section-inner text-center">
          <div class="container">
            <div class="login-wrap">
              <portal-bear></portal-bear>
              <p v-if="notice" class="alert alert-warning">{{ notice }}</p>
              <portal :forgotLink="true" :link="true" size="sm">
                <template slot="login-copy">
                  <h1 class="h2">Log in to TunnelBear</h1>
                </template>
                <template slot="signup-copy">
                  <h1 class="h2">Create a TunnelBear</h1>
                </template>
              </portal>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import portalBear from '@/components/portal-bear/portal-bear'
import portal from '@/components/portal/portal'

export default {
  name: 'authentication',
  components: {
    'portal-bear': portalBear,
    portal
  },
  data () {
    return {
      notice: '',
      watcher: null
    }
  },
  computed: {
    login: function () {
      return this.$route.name === 'login'
    }
  },
  beforeMount () {
    if (this.login) {
      this.checkForNotice()
    }
  },
  created: function () {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push({ name: 'overview' })
    }
    this.watcher = this.$store.watch((state, getters) => getters.isLoggedIn, () => {
      if (this.$route.query.v) {
        this.$router.push({ name: this.login ? 'logged-in' : 'signed-up' })
      } else {
        const toRoute = this.login ? 'overview' : 'download'
        this.$store.dispatch('getNextRoute').then((response) => {
          this.$router.push({ name: response.name, hash: response.hash, query: response.query })
        }, (reason) => {
          this.$router.push({ name: toRoute })
        })
      }
    })
  },
  methods: {
    checkForNotice: function () {
      if (this.$route.query && this.$route.query.notice === 'password_change') {
        this.notice = 'Your password has been changed, please login with your new password.'
      }
    }
  },
  beforeDestroy: function () {
    // unwatch this function
    this.watcher()
  }
}
</script>

<style scoped lang="stylus" src="./authentication.styl" >
